import React, { useState } from 'react';
import axios from 'axios';
import FileSaver from 'file-saver';
import ReactLoading from 'react-loading';
import OnHoverTooltip from './OnHoverTooltip';

const CancelToken = axios.CancelToken;
let cancel;

const ConvertTableToExcel = ({ columns, hiddenColumns, filters, descriptionFilters, table, optionalParams }) => {
    const [, setError] = useState();
    const [isLoading, setIsLoading] = useState();

    const getExcel = () => {
        setIsLoading(true);
        const visibleColumns = columns.filter((col) => {
            return !hiddenColumns.includes(col.name);
        });

        const columnNames = [...new Set(visibleColumns.map((columns) => columns.name))];

        const url = `api/${table}/excel/`;
        cancel && cancel();

        try {
            axios
                .get(url, {
                    params: {
                        filters: JSON.stringify(filters),
                        descriptionFilters: JSON.stringify(descriptionFilters),
                        columns: JSON.stringify(columnNames),
                        optionalParams: JSON.stringify(optionalParams),
                    },
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                    responseType: 'blob',
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/vnd.ms-excel;charset=UTF-8',
                    },
                })
                .then((response) => {
                    FileSaver.saveAs(response.data, `consid_${table}.xlsx`);
                    setIsLoading(false);
                })
                .catch((thrown) => {
                    if (axios.isCancel(thrown)) {
                    } else {
                        const error = thrown.response;
                        setIsLoading(false);
                        setError(error);
                        //TODO Something when error is thrown?
                    }
                });
        } catch (error) {
            //TODO Catch error and do something
        }
    };

    return (
        <OnHoverTooltip labelClassNames='d-flex my-auto' dataFor='excel-dl' showText={null} tooltipType='dark' tooltipPlace='left'>
            <button type='button' className='btn btn-outline-secondary border-0 dropdown d-flex my-auto' onClick={getExcel}>
                {isLoading ? <ExcelLoading /> : <span className='oi oi-data-transfer-download'></span>}
            </button>
            <span>Exporterar vald data till en Excel-fil</span>
        </OnHoverTooltip>
    );
};

export default ConvertTableToExcel;

const ExcelLoading = () => {
    return (
        <div className='d-flex justify-content-center w-100'>
            <ReactLoading type={'bars'} color={'#262f3d'} height={27} width={18} />
        </div>
    );
};
